<template>
  <div class="form-elements">


    <div class="step-contenair">
      <div
        class="elem"
        v-if="
          field.component !== 'BlocHTML' &&
            field.component !== 'BlocHTMLsimple' &&
            field.component !== 'Recap'
        "
      >
        <label>SAVE TO :</label>
        <multiselect
          v-model="field.save_to"
          :options="saveToAvailableComputed"
          :show-labels="false"
          placeholder="Save to"
        >
        </multiselect>
      </div>
      <div class="elem" v-else-if="field.component == 'Recap'">
        <label>GET DATA FROM :</label>
        <multiselect
          v-model="field.save_to"
          :options="saveToRecapComputed"
          :show-labels="false"
          placeholder="Get data from"
        >
        </multiselect>
      </div>

      <div
        align="center"
        class="elem"
        style="background:pink;width:95%;margin:0 auto;margin-top:20px;sdisplay:flex;justify-content:center; color:red; font-weight:bold;line-height:20px;"
        v-if="
          field.component === 'BlocHTMLsimple' &&
            (field.label === 'VALID' ||
              field.label === 'INVALID' ||
              field.label === 'MISSING' ||
              field.label === 'PENDING' ||
              field.label === 'TO_CHECK_AGAIN' ||
              field.label === 'REFUND_DONE' ||
              field.label === 'SEND_TO_LOGISTIC' ||
              field.label === 'MOTIF_NC')
        "
      >
        <p>
          ATTENTION SE TYPE DE BLOC NE PREND PAS EN COMPTE LES VARIABLES <br />
          pour les status merci d'utiliser BlocHTML
        </p>
      </div>

      <div class="elem" v-if="field.component !== 'ApiField'">
        <label>LABEL (html ok):</label>
        <input
          @change="montest"
          type="text"
          placeholder="Label"
          name="field[][label]"
          v-model="field.label"
        />
      </div>

      <div class="elem" v-if="field.name == 'siret'">
        <Checkbox id="autoEnrichment" v-model="field.autoEnrichment"
          ><label for="unique">Auto enrichissement</label></Checkbox
        >
      </div>
      <div class="elem" v-if="field.name == 'siret' && field.autoEnrichment">
        <label>Save enrichment to : </label>
        <multiselect
          v-model="field.enrichment_save_to"
          :options="['company_info_1', 'company_info_2']"
          :show-labels="false"
          placeholder="Save enrichment to"
        >
        </multiselect>
      </div>

      <div
        class="elem"
        v-if="
          field.component !== 'BlocHTML' &&
            field.component !== 'ApiField' &&
            field.component !== 'BlocHTMLsimple'
        "
      >
        <label>VALIDATION LABEL (no html inside):</label>
        <input
          type="text"
          :placeholder="`Defaut: ${field.label}`"
          name="field[][validationLabel]"
          v-model="field.validationLabel"
        />
      </div>

      <div
        class="elem"
        v-if="
          field.component === 'Input' ||
            field.component === 'DateInput' ||
            field.component === 'MultiSelect' ||
            field.component === 'InputNumber'
        "
      >
        <label
          >PLACEHOLDER :
          <span class="defaut">{{ defaut["placeholder"] }}</span></label
        >
        <input
          type="text"
          placeholder="Placeholder"
          v-model="field.placeholder"
        />
      </div>

      <div
        class="elem"
        v-if="field.autocomplete && field.component !== 'Phone'"
      >
        <label>Autocomplete :</label>
        <input type="text" v-model="field.autocomplete" disabled />
      </div>
      <div class="elem" v-if="field.validation != undefined">
        <label
          >RÈGLES DE VALIDATION :
          <a href="https://vee-validate.logaretm.com/v2" target="_blank"
            >(doc)</a
          ></label
        >
        <input
          type="text"
          placeholder="Ex: alpha_num|between:1,11|min_value:18"
          v-model="field.validation"
        />
      </div>
      <div class="elem" v-if="field.unique !== undefined">
        <Checkbox id="unique" v-model="field.unique"
          ><label for="unique">Unique.</label></Checkbox
        >
      </div>

      <div class="elem" v-if="field.type == 'email'">
        <Checkbox
          id="blockTempEmailProviders"
          v-model="field.blockTempEmailProviders"
          ><label for="blockTempEmailProviders"
            >Block temporary email providers</label
          ></Checkbox
        >
      </div>
      <div class="elem" v-if="field.type == 'email'">
        <Checkbox id="blockEmailWithPlus" v-model="field.blockEmailWithPlus"
          ><label for="blockEmailWithPlus">Block email with +</label></Checkbox
        >
      </div>

      <div class="elem" v-if="field.confirmation !== undefined">
        <Checkbox id="confirmation" v-model="field.confirmation"
          ><label for="confirmation">Confirmation</label></Checkbox
        >
      </div>
      <div class="elem" v-if="field.confirmation">
        <label>LABEL CHAMPS CONFIRMATION : </label>
        <input type="text" placeholder="" v-model="field.confirmationLabel" />
      </div>

      <div
        class="elem"
        v-if="
          field.component !== 'BlocHTML' &&
            field.component !== 'BlocHTMLsimple' &&
            field.component !== 'ApiField' &&
            field.component !== 'Recap'
        "
      >
        <Checkbox id="required" v-model="field.required"
          ><label for="required">Champ obligatoire</label></Checkbox
        >
      </div>

      <div
        class="elem"
        v-if="
          field.component !== 'BlocHTML' &&
            field.component !== 'BlocHTMLsimple' &&
            field.component !== 'ApiField' &&
            field.component !== 'Recap'
        "
      >
        <label>Message d'information :</label>
        <input type="text" placeholder="Information" v-model="field.info" />
      </div>

      <div class="elem" v-if="field.component === 'DateInput'">
        <label>DATE MIN :</label>
        <vue-datepicker-local
          name="form[]date_min"
          format="DD MMMM YYYY"
          :local="local"
          v-model="field.min"
        />
      </div>
      <div class="elem" v-if="field.component === 'DateInput'">
        <Checkbox id="dateMaxToday" v-model="field.dateMaxToday"
          ><label for="dateMaxToday">Date max Aujourd'hui</label></Checkbox
        >
      </div>
      <div
        class="elem"
        :class="{ disabled: field.dateMaxToday }"
        v-if="field.component === 'DateInput'"
      >
        <label>DATE MAX :</label>
        <vue-datepicker-local
          name="form[]date_max"
          format="DD MMMM YYYY"
          :local="local"
          v-model="field.max"
        />
      </div>
      <div class="elem" v-if="field.component === 'DateInput'">
        <Checkbox id="isBirthDate" v-model="field.isBirthDate"
          ><label for="isBirthDate"
            >Date d'anniversaire ?
            <span v-if="field.isBirthDate">autocomplete="bday"</span></label
          ></Checkbox
        >
      </div>

      <div class="elem" v-if="field.component === 'Civilite'">
        <label>TYPE : </label>
        <multiselect
          v-model="field.type"
          :options="['select', 'radio']"
          :show-labels="false"
          placeholder="Type"
        >
        </multiselect>
      </div>
      <div class="elem" v-if="field.component === 'Civilite'">
        <label>Label -> Madame :</label>
        <input type="text" v-model="field.LabelMadame" />
      </div>
      <div class="elem" v-if="field.component === 'Civilite'">
        <label>Label -> Monsieur :</label>
        <input type="text" v-model="field.LabelMonsieur" />
      </div>

      <div class="elem" v-if="field.component === 'File'">
        <label>POIDS MAXIMUM (en Octets - 1000 pour 1mo) : </label>
        <input
          type="number"
          placeholder="Poids maximum en Octets"
          v-model.number="field.sizeMax"
        />
      </div>

      <div class="elem" v-if="field.component === 'File'">
        <Checkbox id="isButtonUpload" v-model="field.isButtonUpload"
          ><label for="isButtonUpload">Bouton d'upload ?</label></Checkbox
        >
      </div>

      <div
        class="elem"
        v-if="field.component === 'File'"
        :class="{ disabled: !field.isButtonUpload }"
      >
        <label>LABEL DU BOUTON: </label>
        <input
          type="text"
          placeholder="Information"
          v-model="field.buttonUploadLabel"
          :disabled="!field.isButtonUpload"
        />
      </div>

      <div
        class="elem"
        v-if="field.component === 'File' || field.component === 'MultipleFiles'"
      >
        <label>Accept: </label>
        <input type="text" placeholder=".pdf,image/*" v-model="field.accept" />
      </div>

      <div class="elem" v-if="field.component === 'Adresse'">
        <label>Gmaps countries (max 5) :</label>
        <multiselect
          v-model="field.countries"
          :options="[
            'fr',
            'it',
            'lu',
            'en',
            'nl',
            'tn',
            'pl',
            'gb',
            'be',
            'es',
            'de',
            'si',
            'ro',
            'bg',
            'gr',
            'el',
            'za'
          ]"
          :multiple="true"
          :show-labels="false"
          :limit="5"
          placeholder="Pays accepté"
        >
        </multiselect>
      </div>

      <div class="elem" v-if="field.component === 'PostalCode'">
        <label>Pays :</label>
        <multiselect
          v-model="field.country"
          :options="['fr']"
          :multiple="false"
          :show-labels="false"
          placeholder="Pays"
        >
        </multiselect>
      </div>

      <div class="elem" v-if="field.component === 'Select'">
        <label>Default Option Text :</label>
        <input
          type="text"
          placeholder="Default Option Text"
          v-model="field.defaultOptionText"
        />
      </div>

      <div class="elem" v-if="field.component === 'MultiSelect'">
        <Checkbox id="searchable" v-model="field.searchable"
          ><label for="searchable">Searchable</label></Checkbox
        >
      </div>
      <div class="elem" v-if="field.component === 'MultiSelect'">
        <Checkbox id="closeOnSelect" v-model="field.closeOnSelect"
          ><label for="closeOnSelect">Close On Select</label></Checkbox
        >
      </div>
      <div class="elem" v-if="field.component === 'MultiSelect'">
        <Checkbox id="multiple" v-model="field.multiple"
          ><label for="multiple">multiple</label></Checkbox
        >
      </div>
      <div
        class="elem"
        v-if="field.component === 'MultiSelect'"
        :class="{ disabled: !field.searchable }"
      >
        <Checkbox id="ajax" v-model="field.ajax"
          ><label for="multiple" :disabled="!field.searchable"
            >ajax
            <span v-if="!field.searchable"
              >has to be searchable to enable</span
            ></label
          ></Checkbox
        >
      </div>
      <div
        class="elem"
        v-if="field.component === 'Select'"
      >
        <Checkbox id="dataList" v-model="field.dataList"
          ><label for="dataList"
            >Liste de données
            </label
          ></Checkbox
        >
      </div>
      <div class="elem" v-if="field.component === 'Select' && field.dataList">
        <label>Liste de données :</label>
        <select name="dataListId" id="dataListId" v-model="field.dataListId">
          <option value=""></option>
          <option v-for="dl in dataLists" :key="dl.value" :value="dl.value">{{dl.label}}</option>
        </select>
      </div>
      <div class="elem" v-if="field.component === 'MultiSelect' && field.ajax">
        <label
          >Url to json file :
          <span>[{"value":"value1", "name": "name1"}, ...]</span> :
        </label>
        <input type="text" placeholder="" v-model="field.ajaxUrl" />
      </div>
      <div
        class="elem"
        v-if="field.component === 'MultiSelect'"
        :class="{ disabled: !field.multiple }"
      >
        <label>LIMIT : <span>(illimité = 0)</span> : </label>
        <input
          type="number"
          placeholder=""
          v-model.number="field.limit"
          :disabled="!field.multiple"
        />
      </div>

      <div class="elem" v-if="field.component === 'Phone'">
        <Checkbox id="autocomplete" v-model="field.autocomplete"
          ><label for="autocomplete">Autocomplete</label></Checkbox
        >
      </div>
      <div class="elem" v-if="field.component === 'Phone'">
        <label>Type de téléphone :</label>
        <multiselect
          v-model="field.phoneType"
          :options="['both', 'mobile', 'fixed']"
          :multiple="false"
          :show-labels="false"
          placeholder="Type de téléphone"
        >
        </multiselect>
      </div>
      <div class="elem" v-if="field.component === 'Phone'">
        <label>Pays par défaut :</label>
        <multiselect
          v-model="field.defaultCountry"
          :options="[
            'FR',
            'BE',
            'NL',
            'ES',
            'EN',
            'GB',
            'IT',
            'PL',
            'TN',
            'LU',
            'DE',
            'GR',
            'BG',
            'SI',
            'RO',
            'BE-FR',
            'BE-NL',
            'ES-CAT',
            'EL',
            'ZA'
          ]"
          :multiple="false"
          :show-labels="false"
          placeholder="Pays"
        >
        </multiselect>
      </div>
      <div class="elem" v-if="field.component === 'Phone'">
        <label>Pays acceptés :</label>
        <multiselect
          v-model="field.acceptedCountries"
          :options="[
            'FR',
            'BE',
            'NL',
            'ES',
            'EN',
            'GB',
            'IT',
            'PL',
            'LU',
            'DE',
            'GR',
            'BG',
            'SI',
            'TN',
            'RO',
            'BE-FR',
            'BE-NL',
            'ES-CAT',
            'EL',
            'ZA'
          ]"
          :multiple="true"
          :show-labels="false"
          placeholder="Pays"
        >
        </multiselect>
      </div>
      <div
        class="elem"
        v-if="
          field.component === 'BlocHTML' || field.component === 'BlocHTMLsimple'
        "
        style="width: 100%;"
      >
        <label>HTML :</label>

            <div style="height:290px;width:98%;position:relative">

        <i
          v-if="!codeView"
          @click="codeView = true"
          class="fas fa-solid fa-code edithtml"
          style="top:-35px;right:-15px"
        ></i>
        <i
          v-else
          @click="codeView = false"
          class="fas fa-eye-slash edithtml"
          style="top:-40px;right:-15px"
        ></i>

    <quill-editor
      style="height:220px;"
      ref="myQuillEditor"
      :options="editorOption"
      v-model="field.html"
       v-if="!codeView"
    />
              <prism-editor
            style="width:95%; height:250px"
            v-if="codeView"
            class="my-editor"
            :line-numbers="true"
            :highlight="highlighter"
            v-model="field.html"
          ></prism-editor>
    </div>
      </div>
      <div class="elem" v-if="field.name == 'customer_exp_metric'">
        <label>Number of items :</label>
        <input
          type="number"
          v-model.number="field.numberOfItem"
          style="width: 95%;"
        />
      </div>
      <div class="elem" v-if="field.name == 'customer_exp_metric'">
        <label>Number of red items :</label>
        <input
          type="number"
          v-model.number="field.numberOfRedItem"
          style="width: 95%;"
        />
      </div>
      <div class="elem" v-if="field.name == 'customer_exp_metric'">
        <label>Number of green items :</label>
        <input
          type="number"
          v-model.number="field.numberOfGreenItem"
          style="width: 95%;"
        />
      </div>
      <div class="elem" v-if="field.name == 'customer_exp_metric'">
        <label>Hint for 0 :</label>
        <input type="text" v-model="field.hint0" style="width: 95%;" />
      </div>
      <div class="elem" v-if="field.name == 'customer_exp_metric'">
        <label>Hint for 10 :</label>
        <input type="text" v-model="field.hint10" style="width: 95%;" />
      </div>

      <div class="elem" style="width: 100%;">
        <label>Afficher si :</label>
        <input
          type="text"
          v-model="field.displayIf"
          style="width: 95%;"
          placeholder="this.form.age > 18"
        />
      </div>

      <div
        class="drop"
        v-if="
          field.component === 'Select'  && !field.dataList ||
            field.component === 'Radio' ||
            (field.component === 'MultiSelect' && !field.ajax)
        "
      >
        <hr />
        <div
          class="drop-container"
          v-for="(input, iDrop) in field.options"
          :key="iDrop"
        >
          <div class="elem">
            <label>VALEUR : </label>
            <input
              type="text"
              placeholder="Valeur de l'option"
              v-model="field.options[iDrop].value"
            />
          </div>

          <div class="elem">
            <label>TEXTE : </label>
            <input
              type="text"
              placeholder="Titre de l'option"
              v-model="field.options[iDrop].name"
            />
          </div>
          <div
            class="elem"
            style="width: 15%;"
            v-if="field.component === 'Select'"
          >
            <Checkbox id="other" v-model="field.options[iDrop].other"
              ><label for="other">Autre ?</label></Checkbox
            >
            <i
              class="fa fa-minus-circle deleteOption"
              aria-hidden="true"
              v-on:click="deleteDrop(iDrop)"
            ></i>
          </div>
        </div>
        <div class="addDrop">
          <span v-on:click="addDrop()"
            ><i class="fa fa-plus-square" v-on:click="addDrop()"></i>
            &nbsp;Ajouter une valeur</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var components = require("oxo-form-components");
import Multiselect from "vue-multiselect";
import VueDatepickerLocal from "vue-datepicker-local";
import VueTimepicker from "vue2-timepicker";
import Checkbox from "vue-material-checkbox";
import Rules from "oxo-form-components";
import { fr } from "vuejs-datepicker/dist/locale";
import Vue from "vue";

import Verte from "verte";
import "verte/dist/verte.css";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles
// register component globally
Vue.component(Verte.name, Verte);

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor, Quill } from "vue-quill-editor";

let AlignClass = Quill.import("attributors/style/align");
Quill.register(AlignClass, true);

let BackgroundStyle = Quill.import("attributors/style/background");
Quill.register(BackgroundStyle, true);

let DirectionStyle = Quill.import("attributors/style/direction");
Quill.register(DirectionStyle, true);

let FontStyle = Quill.import("attributors/style/font");
Quill.register(FontStyle, true);

let SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = ["0.8rem", "1rem", "1.5rem", "2rem", "2.6rem"];
Quill.register(SizeStyle, true);

var Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register(Block, true);

const Embed = Quill.import("blots/embed");

Quill.register(
  class extends Embed {
    static create(key) {
      let node = super.create();
      node.setAttribute("contenteditable", true);
      node.setAttribute("class", "headerlogo");
      node.innerHTML = `${key}`;
      return node;
    }
    static value(node) {
      return node.dataset.key;
    }

    static blotName = "customEmbed";
    static className = "customEmbed";
    static tagName = "div";
  }
);

const rules = Rules.load("fr-fr");

export default {
  props: ["field", "saveToAvailable", "saveToAvailableInitially", "operationId"],
  data: function() {
    return {
      dataLists: [],
      codeView : false,
      editorOption: {
        modules: {
          syntax: false,
          toolbar: {
            container: [
              [{ font: [] }, { size: SizeStyle.whitelist }],
              ["bold", "italic", "underline"],
              [
                {
                  color: [
                    "#000000",
                    "#e60000",
                    "#ff9900",
                    "#ffff00",
                    "#008a00",
                    "#0066cc",
                    "#9933ff",
                    "#ffffff",
                    "#facccc",
                    "#ffebcc",
                    "#ffffcc",
                    "#cce8cc",
                    "#cce0f5",
                    "#ebd6ff",
                    "#bbbbbb",
                    "#f06666",
                    "#ffc266",
                    "#ffff66",
                    "#66b966",
                    "#66a3e0",
                    "#c285ff",
                    "#888888",
                    "#a10000",
                    "#b26b00",
                    "#b2b200",
                    "#006100",
                    "#0047b2",
                    "#6b24b2",
                    "#444444",
                    "#5c0000",
                    "#663d00",
                    "#666600",
                    "#003700",
                    "#002966",
                    "#3d1466",
                    "custom-color",
                  ],
                },
              ],
              ["direction", { align: [] }],
              ["link", "image"],
              [
                {
                  placeholder: [
                    "{{ this.form.first_name }}",
                   "{{ this.form.last_name }}",
                   "{{ this.form._id }}",
                   "{{ this.form.motif_nc }}",
                   "{{ this.form.validation_comment }}",
                   "{{ this.form.produit_achete }}",
                   "{{ this.form.enseigne }}"
                  ],
                },
              ],
              ["clean"],
            ],
            handlers: {
              placeholder: function(value) {
                if (value) {
                  const cursorPosition = this.quill.getSelection().index;
                  this.quill.insertText(cursorPosition, value);
                  this.quill.setSelection(cursorPosition + value.length);
                }
              },
              color: function(value) {
                if (value == "custom-color") {
                  value = prompt("Enter Hex/RGB/RGBA");
                }
                this.quill.format("color", value);
              },
            },
          },
        },
      },
      fr: fr,
      multiple: false,
      required: false,
      confirmation: false,
      unique: false,
      rules: rules,
      defaut: [],
      modeList: [
        "verbatim",
        "latin",
        "latin-name",
        "latin-prose",
        "full-width-latin",
        "kana",
        "katakana",
        "numeric",
        "tel",
        "email",
        "url",
      ],
      local: {
        dow: 0,
        yearSuffix: "",
        monthsHead: "Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Decembre".split(
          "_"
        ),
        months: "Jan_Fev_Mar_Avr_Mai_Jun_Jui_Août_Sept_Oct_Nov_Dec".split("_"),
        weeks: "Lun_Mar_Mer_Jeu_Ven_Sam_Dim".split("_"),
        cancelTip: "Quitter",
        submitTip: "Valider",
      },
    };
  },
  components: {
    VueDatepickerLocal,
    Multiselect,
    Checkbox,
    quillEditor,
    PrismEditor,
    Verte
  },
  async mounted() {
    const {data} = await this.$axios.get(`/api/v2/data-list/${this.operationId}`)
    this.dataLists = data.map((datalist)=>{
      return {"value": datalist._id, "label": datalist.title}
    });
  },
  computed: {
    checkBlocHtml() {},
    saveToAvailableComputed() {
      let savable = this.saveToAvailable.filter((st) => {
        return this.field.canSaveTo.includes(st.fieldType);
      });
      if (this.field.save_to) {
        return [this.field.save_to, ...savable.map((st) => st.key)];
      } else {
        return savable.map((st) => st.key);
      }
    },
    saveToRecapComputed() {
      let savable = this.saveToAvailableInitially.filter((st) => {
        console.log(0);
        return this.field.canSaveTo.includes(st.fieldType);
      });
      return savable.map((st) => st.key);
    },
  },
  methods: {
      activateBlockHTML() {
      setTimeout(() => {
        const placeholderPickerItems = Array.prototype.slice.call(
          document.querySelectorAll(".ql-placeholder .ql-picker-item")
        );
        placeholderPickerItems.forEach(
          (item) => (item.textContent = item.dataset.value)
        );
        document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
          "Insert tag" +
          document.querySelector(".ql-placeholder .ql-picker-label").innerHTML;
      }, 500);
      },
      highlighter(code) {
      return highlight(code, languages.js); //returns html
    },
    montest(e) {
      var isStatus = false;
      var statusContent = false;

      console.log(this.field.label)
      if (
        this.field.label === "HEAD" &&
        this.field.component === "BlocHTML"
      ) {
        statusContent =
          "<h1><svg fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' class='w-6 h-6'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'></path></svg> Bonjour <span>{{ this.form.first_name }} {{ this.form.last_name }}</span><br></h1>\n<h3>Votre participation à l'Offre Robot Printemps 2022</h3>\n\n<div class='status_result'>Statut de votre participation : \n<span class='green'  v-if=\"this.form.participationValide ==='VALID'\" ><i class='fa fa-thumbs-o-up'></i> Validé</span>\n\n<span class='red'  v-if=\"this.form.participationValide ==='INVALID'\" ><i class='fa fa-exclamation'></i> Non conforme</span>\n\n<span class='orange' v-if=\"this.form.participationValide =='PENDING' || this.form.participationValide ==='TO_CHECK_AGAIN'\" ><i class='fa fa-clock-o'></i> En attente</span>\n\n<span  class='green' v-if=\"this.form.participationValide ==='REFUND_DONE'\" ><i class='fa fa-thumbs-o-up'></i> Remboursement effectué</span>\n\n<span  class='orange' v-if=\"this.form.participationValide ==='MISSING'\" ><i class='fa fa-exclamation'></i> à corriger</span>\n</div>\n<br >";
        isStatus = true;
              console.log('0',statusContent)
      }

      if (
        this.field.label === "VALID" &&
        this.field.component === "BlocHTML"
      ) {


        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'VALID'"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Informations : </span> Votre participation a été validée par nos équipes. Nous allons effectuer votre remboursement dans un délais de 10 jours ouvrés.</p><br>\n</div>";
        isStatus = true;
      }
      if (
        this.field.label === "INVALID" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'INVALID'"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Informations : </span> Nous n'avons pas été en mesure de valider votre participation conformément au règlement de l'opération. Celle-ci est définitivement clôturée.</p>\n<br>\n</div>";
        isStatus = true;
      }
      if (
        this.field.label === "PENDING" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'PENDING'"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Informations : </span> Votre participation a bien été enregistrée. Nous la traiterons dans les meilleurs délais.</p>\n<br>\n</div>";
        isStatus = true;
      }
      if (
        this.field.label === "TO_CHECK_AGAIN" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'TO_CHECK_AGAIN'"
        );
        statusContent =
          "<div class='status_infos'><p><span>Statut de votre participation : </span> Nous avons bien reçu votre mise à jour, votre participation sera traitée dans les meilleurs délais.</p><br></div>";
        isStatus = true;
      }
      if (
        this.field.label === "MISSING" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'MISSING'"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Informations : </span> Votre participation n'est pas valide en l'état, vous avez un délai de 7 jours pour apporter les modifications nécessaires à votre demande.</p>\n<br >\n</div>";
        isStatus = true;
      }
      if (
        this.field.label === "REFUND_DONE" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'REFUND_DONE'"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Informations : </span> Votre remboursement a été effectué. Nous espérons que vous êtes satisfait du traitement de votre demande. \n<br >\n</p>\n</div>";
        isStatus = true;
      }
      if (
        this.field.label === "SENT_TO_LOGISTIC" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "this.form.participationValide === 'SENT_TO_LOGISTIC'"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Informations : </span> Nous n'avons pas été en mesure de valider votre participation conformément au règlement de l'opération. Celle-ci est définitivement clôturée.</p>\n<br>\n</div>";
        isStatus = true;
      }
      if (
        this.field.label === "MOTIF_NC" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "(this.form.participationValide === 'INVALID' || this.form.participationValide === 'MISSING') && this.form.motif_nc"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Motif de non conformité :</span> {{ this.form.motif_nc }}</p>\n</div>";
        isStatus = true;
      }

      if (
        this.field.label === "COMMENTAIRES" &&
        this.field.component === "BlocHTML"
      ) {

        Vue.set(
          this.field,
          "displayIf",
          "(this.form.participationValide === 'INVALID' || this.form.participationValide === 'MISSING') && this.form.validation_comment"
        );
        statusContent =
          "<div class='status_infos'>\n<p><span>Commentaires : </span>{{ this.form.validation_comment }} </p> \n</div>";

      }



      if (statusContent) {

        this.activateBlockHTML()

        this.$swal({
          title: "Status détécté",
          html:
            "Voulez-vous copier le contenu du status <br><b>" +
            this.field.label +
            "</b> par défaut ?",
          type: "info",
          showCancelButton: true,
          cancelButtonText: "Non",
          confirmButtonText: "Oui",
        }).then((result) => {
          if (result.value) {

            Vue.set(this.field, "html", statusContent);
            statusContent = false
          }
        });
      }
    },
    addDrop() {
      this.field.options.push({});
    },
    deleteDrop(index) {
      Vue.delete(this.field.options, index);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

.form-elements  {
   .ql-toolbar.ql-snow {
    height: 45px !important;
    padding-top: 0px !important;
    display: flex;
    align-items: flex-end;
   }

   .ql-snow .ql-picker {
     height: 28px;
   }
}


.datepicker {
  width: 300px;
  font-family: "PT Sans", sans-serif;

  input {
    font-family: "PT Sans", sans-serif;
    border-radius: 5px;
    border: none;
    width: 100%;
  }
}

.datepicker-popup {
  width: 300px !important;
  font-family: "PT Sans", sans-serif;
}


.headlogo {
  width: 100%;
  margin-top: -20px;
  text-align: center;
}

</style>

